import { Card, Flex, Title } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import FoldableSection from "../../../../../../components/FoldableSection/FoldableSection";
import { IssueConnectedIssuesSection } from "./IssueConnectedIssuesSection";
import LocalErrorBoundary from "../../../../../../util/LocalErrorBoundary";

type IIssueConnectionsSectionProps = {
  projectId: string;
  issue: IIssueApi;
};

const IssueConnectionsSection = ({ projectId, issue }: IIssueConnectionsSectionProps) => {
  return (
    <FoldableSection storageKey="issue-modal-connections">
      <FoldableSection.Header>
        <Flex>
          <Title order={6}>Tilkoblinger</Title>
        </Flex>
      </FoldableSection.Header>
      <FoldableSection.Body>
        <LocalErrorBoundary id="IssueConnectionsSection">
          <Card w="100%" bg="#f8f9fa" bd="1px solid var(--mantine-color-warmgray-2)">
            <IssueConnectedIssuesSection issue={issue} boardId={issue?.issueBoard?._id} projectId={projectId} />
          </Card>
        </LocalErrorBoundary>
      </FoldableSection.Body>
    </FoldableSection>
  );
};

export default IssueConnectionsSection;
